module.exports = {
	"general": {
		"accept": "accept",
		"add": {
			"attachments": "add attachments",
			"images": "add images",
			"invoiceDocuments": "Add invoices and documents.",
			"file": "add file",
			"files": "add files",
			"filesDocuments": "add files and documents"
		},
		"attachment_one": "{{count}} attachment",
		"attachment_other": "{{count}} attachments",
		"attachments": "Attachments",
		"attachment": {
			"manage": "manage attachments"
		},
		"back": "Back",
		"check": "Check",
		"claim": "mobile field service software",
		"comment": "Comment",
		"commentYour": "your comment",
		"confirmation": "Confirmation",
		"contact": "Contact",
		"contacts": "Contact",
		"customerX": "customer X",
		"decline": "reject",
		"description": "Description",
		"details": "details",
		"documents": "documents",
		"document_one": "document",
		"document_other": "documents",
		"done": "done",
		"edit": "edit",
		"enter": "send",
		"error": {
			"describe": "Describe the situation",
			"transmission": "Error while submitting"
		},
		"escalationManagement": "escalation management",
		"exttechnician": "ext. Technician",
		"filed": "rejected",
		"in": {
			"appendix": "in appendix",
			"report": "in the report"
		},
		"imprint": "imprint & privacy policy",
		"loading": "Loading",
		"names": "first name last name",
		"namesFirst": "Enter a name first",
		"next": "next",
		"noInput": "no input",
		"oclock": "",
		"orIsIn": "or is in",
		"phone": {
			"phone": "phone:",
			"mobile": "mobile:"
		},
		"plus": "plus",
		"rejected": "was rejected",
		"report": "Report",
		"rework": "rework",
		"send": "send",
		"show": "show",
		"showPlace": "show place",
		"serviceObject": "Location",
		"start": "start",
		"step": {
			"edit": "edit step",
			"finished": "You had processed {{stepsFinished}} of {{steps}} steps",
			"next": "next step",
			"single": "step"
		},
		"transferred": "transferred",
		"to": "to",
		"upload": {
			"progress": "Upload in progress",
			"upload": "upload"
		},
		"valueInput": "value input"
	},
	"job": {
		"accepted": "Job accepted",
		"cancel": "Cancel Job",
		"end": "End Job",
		"decline": "Reject Job",
		"declineReason": "You will reject the job with this. Please tell us a reason:",
		"hold": "Job stopped",
		"the": "The Job",
		"send": "Send Job",
		"sent": "Job sent"
	},
	"protocol": {
		"final": "final protocol"
	},
	"report": {
		"create": "Create your report",
		"edit": "Edit Report",
		"final": {
			"show": "show final report"
		},
		"generate": "Create a report in <strong>{{apiSteps}} steps</strong>",
		"send": "send your report",
		"show": "show report"
	},
	"signature": {
		"add": "add Signature",
		"missing": "There are {{signaturesOpen.length}} signatures missing for transmission.",
		"no": "signature empty/no name",
		"now": "sign now",
		"onlyNo": "no signature available",
		"open": "signature open",
		"signature": "signature",
		"signatureTechnichian": "signature technician"
	},
	"enumeration": {
		"done": "Done",
		"rework": "rework needed"
	},
	"intlDateTime": "{{val, datetime}}"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/translation.json
// module id = 688
// module chunks = 0